





import { Component, Vue,Prop } from 'vue-property-decorator'
@Component({})
export default class MdcOverline extends Vue{
  @Prop({default:'span'})
  tag!:string
}
